export default __webpack_public_path__ + "static/media/homepage-background.cb951de3.jpg";